/**
 * @file
 * Facets accordion helper JS.
 */

// Show/hide empty facets accordion.
let $accordion = $('.facet-accordion', context);

$accordion.once('profile-listing').each(function() {
  let $this = $(this);
  if ($this.find('.accordion-content .facet-empty').length) {
    $this.hide();
  }
  else {
    $this.show();
  }
});
